import gql from 'graphql-tag';

export const GET_GOLFCOURSE = gql`
    query ( $golf_group_code: String! ) {
        getGolfCourse (golf_group_code: $golf_group_code) {
            golf_code
            golf_name
        }
    }
`;

export const GET_GOLFCOURSE_SELECE_LIST = gql`
  query(
      $golf_group_code: String!
      $golf_code: String
      $user_id: Int
  ) {
    GolfCourseSelectList(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        user_id: $user_id
    ){
      golf_name
      golf_code
    }
  }
`;
